<div class="custom-tooltip-template" *ngIf="tooltip" [style.left]="left + 'px'" [style.top]="top + 'px'">
  <ng-container *ngTemplateOutlet="tooltip"></ng-container>
</div>
